import { Element, Listen, State, Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-card',
  styleUrl: 'spw-card.scss',
  shadow: true,
})
export class SpwCard {
  @Element() el: HTMLSpwCardElement;
  @State() hasImage: boolean = false;

  /** Type d'élément du bouton */
  @Prop() elementType: string = 'a';
  /** Spécifie le lien si nécessaire */
  @Prop() href?: string;
  /** Attribut target, s'applique uniquement si href est rempli */
  @Prop() target: string = '_self';
  /** Remplit l'attribut rel */
  @Prop() rel?: string;

  /** Si vrai, les cartes ont la même hauteur */
  @Prop() fullHeight: boolean = false;
  /** Si désactivée, la carte n'est pas utilisable */
  @Prop() disabled: boolean = false;
  /** Remplit l'attribut aria-label, utilisé à des fins d'accessibilité */
  @Prop() accAriaLabel?: string;

  componentWillLoad() {
    this.checkForImage();
  }

  @Listen('slotchange')
  slotChanged() {
    this.checkForImage();
  }

  @Listen('mouseenter')
  onMouseEnter() {
    this.setImageHovered(true);
  }

  @Listen('mouseleave')
  onMouseLeave() {
    this.setImageHovered(false);
  }

  private checkForImage() {
    requestAnimationFrame(() => {
      const imageElement = this.el.querySelector('spw-card-image');
      const contentElement = this.el.querySelector('spw-card-content');
      this.hasImage = !!imageElement;
      if (!this.hasImage) {
        contentElement.classList.add('--no-image');
      }
    });
  }

  private setImageHovered(isHovered: boolean) {
    const imageElement = this.el.querySelector('spw-card-image');
    const titleElement = this.el.querySelector('spw-card-title');
    if (imageElement && this.href) {
      imageElement.classList.toggle('--hovered', isHovered);
    }
    if (titleElement && this.href) {
      titleElement.classList.toggle('--hovered', isHovered);
    }
  }

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-card': true,
      'spw-card--hoverable': !!this.href,
      'spw-card--no-image': !this.hasImage,
    };
  }

  render() {
    const { href, rel, target } = this;
    const TagType = this.href === undefined ? 'div' : 'a';
    const attrs =
      TagType === 'div'
        ? {}
        : {
            href,
            rel,
            target,
          };

    const ariaAttributes = {
      'aria-label': this?.accAriaLabel,
      'aria-disabled': this.disabled ? 'true' : null,
    };

    return (
      <Host class={{ '--is-full-height': this.fullHeight }}>
        <article class={this.elementClass}>
          <TagType {...attrs} {...ariaAttributes} class="spw-card__link">
            <slot></slot>
          </TagType>
        </article>
      </Host>
    );
  }
}
